import React from 'react'
import pic1 from '../photo_video/breakfast.jpg'
import { useNavigate } from 'react-router-dom'
function Diet() {
    const neviagte = useNavigate()

    return <>
        <div className='d-md-flex d-grid' id='dietplanning'>
            <div className='p-md-3 order-lg-1 order-2 d-flex justify-content-center'>
                <div className='dietPic'>
                    <img className='w-100 h-100' src={pic1} alt="" />
                </div>
            </div>
            <div className='container order-lg-2 order-1 d-flex justify-content-center flex-column align-items-center'>
                <div className='mb-3 mt-3 position-relative'><h2 className='pageHeader'>Diet Planning</h2></div>
                <p className='borderLeft mt-3'>A well-balanced diet is the foundation of a healthy lifestyle. Proper diet planning involves making thoughtful and informed choices about the foods you eat, ensuring that your body receives the necessary nutrients to function optimally. Whether your goal is to lose weight, gain muscle, or simply improve your overall well-being, a carefully crafted diet can make a significant difference. </p>
                <p className='borderLeft mt-3 mb-5'>Whole foods, such as fruits, vegetables, whole grains, lean proteins, and healthy fats, are rich in nutrients and generally have fewer additives and preservatives. Incorporating more whole foods into your diet can improve your nutrient intake and support better health. </p>
                <div className='w-100'>
                    <h4>Our Services</h4>
                    <hr
                        className="mb-4 mt-0  text-start"
                        style={{ width: "80px", backgroundColor: "#f6004c", height: "2px", opacity: 1, border: 'none' }}
                    />
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Workout Session</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Personlized Meal Plane</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Wellness Master Class</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Celebration Of Success</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Nutrition Master Class</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">Lots Of Gifts</a>
                    </p>
                    <p className='text-start'>
                        <a style={{ textDecoration: 'none' }} className="footerLink text-dark">One On 1 Coaching</a>
                    </p>
                </div>
            </div>
        </div>
        <div className='w-100 text-center mt-4 mb-4'>
            <button className='submitBtn' onClick={(e) => { neviagte('/contactus') }} id="mc-embedded-subscribe">
                Register Now
            </button>
        </div>
    </>

}

export default Diet
